import React from 'react';
import styled from 'styled-components';
import BrainRolplay from '../images/brainrolplay.svg';

const StyledWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(157, 23, 41, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: ${props => props.isExiting ? 0 : 1};
  transition: opacity 0.5s ease-out;

  .loader-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }

  .logo {
    width: 140px;
    height: auto;
    margin-bottom: 0.5rem;
  }

  .welcome-text {
    color: rgba(255, 255, 255, 0.95);
    font-size: 1.25rem;
    text-align: center;
    margin: 0;
    font-weight: 400;
    letter-spacing: 0.5px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    --color: rgba(255, 255, 255, 0.95);
    --animation: 1.5s ease-in-out infinite;
    margin-top: 1rem;
  }

  .loader .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 8px;
    height: 8px;
    margin: 0 6px;
    background-color: var(--color);
    border-radius: 50%;
    animation: bounce var(--animation);
  }

  .circle:nth-child(2) {
    animation-delay: 0.1s;
  }

  .circle:nth-child(3) {
    animation-delay: 0.2s;
  }

  .circle:nth-child(4) {
    animation-delay: 0.3s;
  }

  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
      background-color: rgba(255, 255, 255, 1);
    }
  }
`;

const Bienvenida = ({ isExiting }) => {
  return (
    <StyledWrapper isExiting={isExiting}>
      <div className="loader-container">
        <img src={BrainRolplay} alt="Brain Rolplay Logo" className="logo" />
        <h1 className="welcome-text">Bienvenido a Rolplay Reports</h1>
        <div className="loader">
          <div className="circle" />
          <div className="circle" />
          <div className="circle" />
          <div className="circle" />
        </div>
      </div>
    </StyledWrapper>
  );
}

export default Bienvenida;
